import { createContext } from "react";
export const EditorStateContext = createContext(null);
